/**************************************************
 * Nombre:       LineaAnimada
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {motion, useScroll, useTransform} from "framer-motion";

const LineaAnimada = ({lista}) => {
    const speed = 1;
    const {scrollY} = useScroll();
    const x = useTransform(scrollY, (value) => -value * speed);
    const y = useTransform(scrollY, (value) => value * speed);

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{overflowX: 'hidden'}}
        >


            <Grid
                component={motion.div}
                container
                justifyContent="flex-start"
                alignItems="center"
                sx={{backgroundColor: '#1A1A1A', py: 1, zIndex: 2, minWidth: 3500, maxLines: 1}}
                style={{x: x, transitionTimingFunction: "spring(1 100 10 10)", transition: "transform 3s"}}
            >

                {lista.map((item) => {
                    return (

                        <Typography
                            sx={{
                                color: '#fff',
                                mx: 0.2,
                                fontSize: 18,
                                maxLines: 1,
                                fontWeight: 400,
                                letterSpacing: 4,

                            }}>{`${item}  -  `}</Typography>


                    )
                })}

            </Grid>
        </Grid>
    )

}
export default LineaAnimada